import React, { useState } from 'react';
import { generateBotUrl } from '../utils/botUrlUtils';

function BotLinkWithCopy({ externalId }) {
    const [copied, setCopied] = useState(false);
    const [isLinkHover, setIsLinkHover] = useState(false);
    const [isCopyHover, setIsCopyHover] = useState(false);

    const botUrl = generateBotUrl(externalId);

    const hasUrl = botUrl && botUrl.includes("t.me");
    const statusColor = hasUrl ? "#10b981" : "#ef4444";

    const statusBg = hasUrl
        ? (isLinkHover ? "#d1fae5" : "#ecfdf5")
        : (isLinkHover ? "#fee2e2" : "#fef2f2");

    const handleCopy = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!hasUrl) return;

        navigator.clipboard.writeText(botUrl).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '3px',
            flexShrink: 0
        }}>
            {/* Link */}
            <a
                href={hasUrl ? botUrl : "#"}
                target="_blank"
                rel="noreferrer"
                title={hasUrl ? "Відкрити в Telegram" : "Посилання відсутнє"}
                onMouseEnter={() => setIsLinkHover(true)}
                onMouseLeave={() => setIsLinkHover(false)}
                style={{
                    textDecoration: 'none',
                    fontSize: '12px',
                    backgroundColor: statusBg,
                    width: '30px',
                    height: '30px',
                    borderRadius: '6px',
                    border: `1px solid ${isLinkHover ? statusColor : statusColor + '44'}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: '0.2s',
                    cursor: hasUrl ? 'pointer' : 'default'
                }}
                onClick={(e) => !hasUrl && e.preventDefault()}
            >
                {hasUrl ? '🔗' : '⚠️'}
            </a>

            {/* Copy */}
            <button
                type="button"
                onClick={handleCopy}
                onMouseEnter={() => setIsCopyHover(true)}
                onMouseLeave={() => setIsCopyHover(false)}
                disabled={!hasUrl}
                title="Копіювати URL для бота"
                style={{
                    cursor: hasUrl ? 'pointer' : 'not-allowed',
                    width: '30px',
                    height: '30px',
                    fontSize: '12px',
                    borderRadius: '6px',
                    border: isCopyHover && hasUrl ? '1px solid #4f46e5' : '1px solid #d1d5db',
                    backgroundColor: copied ? '#4f46e5' : (isCopyHover && hasUrl ? '#f8f9ff' : '#fff'),
                    color: copied ? '#fff' : '#374151',
                    transition: 'all 0.2s ease',
                    outline: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                }}
            >
                {copied ? '✅' : '📋'}
            </button>
        </div>
    );
}

export default BotLinkWithCopy;